import { widgetsTypes } from '@/utils/widgets/widgetsTypes'
import { validationsTypes, customValidators } from '@/utils/validations/validations'

const populateData = (WidgetType, widget) => {
  const populatedWidget = new WidgetType()
  for (const field in populatedWidget) {
    if (widget[field] !== undefined) {
      // if data has children
      if (typeof populatedWidget[field] === 'object') {
        for (const nestedField in populatedWidget[field]) {
          // if nested Widget
          if (Array.isArray(populatedWidget[field][nestedField])) {
            populatedWidget[field][nestedField] = widget[field][nestedField]?.map(
              child => {
                // if the child is a Widget
                if (child.type) return populateData(widgetsTypes[child.type], child)
                // if the child is value
                else return child
              }
            )
          } else {
            if (widget[field][nestedField] !== undefined) {
              populatedWidget[field][nestedField] = widget[field][nestedField]
            }
          }
        }
      } else {
        populatedWidget[field] = widget[field]
      }
    }
  }
  return populatedWidget
}

/**
 * Widget
 * title - UI text
 * type need to define components in "<component :is="listItem.type">
 * data - state
 */
export default class Widget {
  title = ''
  type = ''
  requiredFields = []
  requiredMsg = 'Обязательное поле'
  validators = {}

  static populateList (widgetList = []) {
    return widgetList.map(widget => {
      if (!widget) throw new Error('widget is required')
      const widgetType = widgetsTypes[widget.type]
      if (!widgetType) throw new Error(`widget type ${widget.type} not found`)
      return Widget.populate(widget, widgetType)
    })
  }

  static populate (widget, widgetType) {
    return populateData(widgetType, widget)
  }

  static validate (value, validatorName) {
    const validator = validationsTypes[validatorName] || customValidators[validatorName]
    return validator(value)
  }

  constructor (title = '', type) {
    if (!type) {
      throw new Error('Missing required Widget param "type"')
    }
    this.title = title
    this.type = type
  }
}
